import IAudioSequenceData from "./IAudioSequenceData";
import IMusic from "./IMusic";
import { GameHowl } from "./GameHowl";

export default class AudioSequence implements IMusic {
    public isActive: boolean;
    public saveVolume: number;
    public isMuted: boolean;
    public trackIndex: number;
    protected readonly data: IAudioSequenceData;

    constructor(data: IAudioSequenceData) {
        if (!data) {
            throw new Error("data can not be null or undefined!");
        }

        if (!data.tracks || data.tracks.length < 2) {
            throw new Error("data.tracks must contain at least 2 GameHowls!");
        }

        if (!data.sequencer) {
            throw new Error("data.sequencer can not be null or undefined!");
        }

        if (isNaN(data.bpsMultiplier)) {
            throw new Error("data.bpsMultiplier can not be NaN!");
        }

        if (data.bpsMultiplier <= 0) {
            throw new Error("data.bpsMultiplier must be greater than zero!");
        }

        if (isNaN(data.bpm)) {
            throw new Error("data.bpm can not be NaN!");
        }

        if (data.bpm <= 0) {
            throw new Error("data.bpm must be greater than zero!");
        }

        this.data = data;
        this.trackIndex = 0;
    }

    public get loop(): boolean {
        return this.currentSound.loop();
    }

    public set loop(value: boolean) {
        this.data.tracks.forEach(track => {
            track.loop(value);
        });
    }

    public get volume(): number {
        return this.currentSound.volume();
    }

    public set volume(value: number) {
        this.data.tracks.forEach(track => {
            track.volume(value);
        });
    }

    public get name(): string {
        return this.data.masterSoundId;
    }
    
    public get snd(): GameHowl {
        return this.currentSound;
    }

    public get currentSound(): GameHowl {
        return this.data.tracks[this.trackIndex];
    }

    public get tracks(): GameHowl[] {
        return this.data.tracks;
    }

    public get bpm(): number {
        return this.data.bpm;
    }

    public get bpsMultiplier(): number {
        return this.data.bpsMultiplier;
    }
}
